import { useRef, useState } from 'react'


interface Props {
  polyhedron: (THREE.BoxGeometry | THREE.DodecahedronGeometry | THREE.SphereGeometry)[],
  color: string;
}

export default function Polyhedron({ polyhedron, color, ...props }: Props) {
  const ref = useRef()
  const [count, setCount] = useState(2)

  // console.log(polyhedron[count].uuid)

  return (
    <mesh
      {...props}
      // @ts-ignore
      ref={ref}
      onPointerDown={() => {
        setCount((count + 1) % 3)
      }}
      geometry={polyhedron[count]}>
      <meshBasicMaterial color={color} wireframe />
    </mesh>
  )
}